<template>
  <section>
    <h3 class="h-title">服务基础信息</h3>  
    <el-form class="e-form f-b" ref="cForm1" :model="cForm1" label-width="160px"  label-position="left" :rules="setpFormRules1">
      <el-form-item label="选择管理人" prop="lawFirmObj">
        <el-select v-model="cForm1.lawFirmObj" @change="setLawFirm" value-key="nodeName" placeholder="请选择律所" style="width: 100%">
          <el-option
            v-for="dict in lawOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择权威节点" prop="authorityNodeArr">
        <el-select v-model="cForm1.authorityNodeArr" 
        @remove-tag="changeNode" 
        @change="seteNode" multiple 
        filterable 
        @input.native="filterData"
        @clear="clearData"
        value-key="nodeName" placeholder="请选择权威节点" style="width: 100%">
          <el-option
            v-for="item in nodeOptions"
            :key="item.id"
            :label="item.nodeName"
            :disabled="item.isRequire == '0'"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm1.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="治理标的名称" prop="targetName">
        <el-input v-model="cForm1.targetName" :maxlength="32" placeholder="请输入<=32文字" />      
      </el-form-item>
      <el-form-item label="债权人名称" prop="creditorName">
        <el-input v-model="cForm1.creditorName" disabled />
      </el-form-item>
      <el-form-item label="债务人名称" prop="debtorName">
        <el-input v-model="cForm1.debtorName" @blur="setQrf" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="确认方名称" prop="confirmerName">
        <el-input v-model="cForm1.confirmerName" disabled />
      </el-form-item>
      <el-form-item label="增信主体1名称" prop="subjectName1">
        <el-input v-model="cForm1.subjectName1"  :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <div v-for="index in cForm1.subjectNum-1" :key="index">
        <el-form-item :label="`增信主体${index+1}名称`" :prop="`subjectName${index+1}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1['subjectName'+(index+1)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
          <el-button class="s-but" type="orange" @click="delMainNum(index)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
        </el-form-item>
      </div>
      
      <el-button v-show="cForm1.subjectNum<10" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addMainNum">增信主体</el-button>

      
      <el-form-item class="w-70" label="债权规模(万元)" prop="creditAmount" >
        <el-input-number v-model="cForm1.creditAmount" controls-position="right" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item class="w-70" label="债权余额(万元)" prop="creditBlance">
        <el-input-number v-model="cForm1.creditBlance" controls-position="right" :precision="4" :step="0.1" :min="cForm1.entrustAmount||0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
      </el-form-item>
      <div class="tag">如债权规模与债权余额不一致，需提供相关证明文件并存储，如确权函等。</div>
      <el-form-item class="w-70" label="委托治理规模(万元)" prop="entrustAmount">
        <el-input-number v-model="cForm1.entrustAmount" controls-position="right" :precision="4" :step="0.1" :min="0" :max="cForm1.creditBlance||Infinity" placeholder="请输入数字，小数点后2位, <=债权余额" style="width: 100%"></el-input-number>
      </el-form-item>
      <el-form-item label="债权清偿方式" prop="repaymentMethod">
        <el-select v-model="cForm1.repaymentMethod" placeholder="请选择债权清偿方式" style="width: 100%">
          <el-option
            v-for="dict in repayOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="债权到期日" prop="creditExpire">
          <el-date-picker  style="width: 100%"
              type="date"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              v-model="cForm1.creditExpire"
							:picker-options="pickerOptions"
            >
          </el-date-picker>
      </el-form-item>
      <div style="display: flex; ">
        <el-form-item label="委托期限" prop="entrustPeriodStart" style="flex: 1">          
            <el-date-picker style="width: 100%"
                type="date"
                format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd"
                placeholder="请选择开始日期"
                v-model="cForm1.entrustPeriodStart"
                :picker-options="startTimeOptions"
              >
            </el-date-picker>
        </el-form-item> 
        <el-form-item label="-" prop="entrustPeriodEnd" style="flex: 1" label-width="30px" class="hide-required"> 
            <el-date-picker style="width: 100%"
                type="date"
                format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd"
                placeholder="请选择结束日期"
                v-model="cForm1.entrustPeriodEnd"
                :picker-options="endTimeOptions"
              >
            </el-date-picker>
        </el-form-item> 
      </div>
      <div class="tag">如在治理期限内，标的债权实际偿付或转让情形，本次治理服务即告终结</div>
      <el-form-item label="担保措施" prop="guaranteeStep">
        <el-input v-model="cForm1.guaranteeStep" type="areatext" :maxlength="500" placeholder="请输入<=500文字" />
      </el-form-item>
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>	
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
    name: "step1",
    props: ["active", "id"],
		data() {
			return {    
        cForm1: {
          subjectNum: 1
        },
				setpFormRules1: {
          lawFirmObj: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          authorityNodeArr: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          saveType: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          targetName: [
            { required: true, message: "请输入", trigger: "blur" },
          ],
          debtorName: [
            { required: true, message: "请输入", trigger: "blur" }
          ],         
          creditAmount: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          creditBlance: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          entrustAmount: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          repaymentMethod: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          creditExpire: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          entrustPeriodStart: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          entrustPeriodEnd: [
            { required: true, message: "请选择", trigger: "change" }
          ],
        },
        pickerOptions: {
					disabledDate:(time)=> {
						if (this.cForm1.entrustPeriodStart) {
              return (time.getTime() < new Date(this.cForm1.entrustPeriodStart).getTime() || time.getTime() < Date.now()) ;
            }else {
							return time.getTime() < Date.now()
						}							
					}
				},
        startTimeOptions: {
					disabledDate:(time)=> {
						if (this.cForm1.creditExpire && this.cForm1.entrustPeriodEnd) {
              return (time.getTime() > new Date(this.cForm1.creditExpire).getTime()-1 * 24 * 3600 * 1000 || time.getTime() > new Date(this.cForm1.entrustPeriodEnd).getTime()-1 * 24 * 3600 * 1000);
            }else if (this.cForm1.entrustPeriodEnd) {
              return time.getTime() > new Date(this.cForm1.entrustPeriodEnd).getTime()-1 * 24 * 3600 * 1000;
            }else if (this.cForm1.creditExpire) {
              return time.getTime() > new Date(this.cForm1.creditExpire).getTime()-1 * 24 * 3600 * 1000;
            }
					}
				},
        endTimeOptions: {
					disabledDate:(time)=> {
						if (this.cForm1.entrustPeriodStart) {
              return time.getTime() < new Date(this.cForm1.entrustPeriodStart).getTime();
            }
					}
				},
        butLoading: false,       
        account: sessionStorage.account,
        lawOptions: [],
        nodeOptions: [],
        nodeTotal: 0,
        typeOptions: [],
        repayOptions: [],
        lawFirmOptions: [],
        queryParams: {
          pageNum: 1,
          pageSize: 1000,
          businessType:'3', 
          status: '0'
        }
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 1) {
          window.scrollTo(0,0);
          var param = JSON.parse(sessionStorage.setpForm);
          param.creditAmount = param.creditAmount/10000
          param.creditBlance = param.creditBlance/10000
          param.entrustAmount = param.entrustAmount/10000
          this.cForm1 = param;
          this.getLawFirm()
          this.getNodeList()
          this.init()
        } 
      }
    },
    mounted(){
      this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
      if(this.id) {
        this.getDetial();
      }else{
        this.getLawFirm()
        this.getNodeList()
      }          
      this.cForm1.creditorName = sessionStorage.projectName                  
      
    },
    methods: {
      init(){
        // 金额
        if(this.cForm1.creditAmount == null){
          delete this.cForm1.creditAmount
        }
        if(this.cForm1.creditBlance == null){
          delete this.cForm1.creditBlance
        }
        if(this.cForm1.entrustAmount == null){
          delete this.cForm1.entrustAmount
        }

        // 主体个数
        for(let j=10; j>=1; j--){
          this.$set(this.cForm1, 'subjectNum', 1)
          if(this.cForm1['subjectName'+(j)]){
            this.$set(this.cForm1, 'subjectNum', j)
            return
          }
        }
      },
      // 查询权威节点
      filterData(e){
        this.queryParams.pageNum = 1
        this.queryParams.nodeName = e.target.value;
        this.selectNode();
      },
      // 清空权威节点
      clearData() {
        this.queryParams.nodeName = ""
        this.queryParams.pageNum = 1
        this.selectNode();
      },
      selectNode(){
        this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
          if(response.code == 200){
            this.nodeOptions = response.rows
          }else {
            this.$message.error(response.msg);
          } 
        })
      },
      setQrf(){
        this.$set(this.cForm1, 'confirmerName', this.cForm1.debtorName)
      },
      //获取详情
      getDetial() {
          this.$api.creditorsRights.creDetail(this.id).then(res => {
              if(res.code==200){
                  this.cForm1 = Object.assign({}, res.data); 	                  
                  this.getLawFirm()
                  this.getNodeList()
                  this.init()
              }else {
                  this.$message.error(res.msg);
              }    
          });      
      },
      cSubmitForm(type){        
        // 用户经理
        this.cForm1.userManager = sessionStorage.applyCustomerName
        this.cForm1.userManagerPhone = sessionStorage.applyCustomerContact
        this.cForm1.userManagerAccount = sessionStorage.applyCustomerAccount
        this.cForm1.submitName = sessionStorage.projectName

        this.$refs["cForm1"].validate(valid => {
          if (valid) {
            if(this.nodeTotal >= 4){
              if(this.cForm1.authorityNodeArr.length !== 4){
                this.$message.error("权威节点请选择4个！");
                return false
              }
            }else {
              if(this.cForm1.authorityNodeArr.length !== this.nodeTotal){
                this.$message.error("权威节点请选择"+this.nodeTotal+"个！");
                return false
              }
            }
            this.cForm1.authorityNode = []
            this.cForm1.authorityNodeArr.forEach(item => {
              this.cForm1.authorityNode.push({
                id: item.id,
                name: item.nodeName
              })
            })
            this.cForm1.authorityNode = JSON.stringify(this.cForm1.authorityNode)
            
            var param = Object.assign({}, this.cForm1)
            param.creditAmount = param.creditAmount*10000
            param.creditBlance = param.creditBlance*10000
            param.entrustAmount = param.entrustAmount*10000
            console.log(param)
            console.log(this.cForm1)
            if(type == '0'){
              param.status = '0'
              this.$api.creditorsRights.addAndUpd(JSON.stringify(param)).then(response => {
                this.butLoading = false;
                if(response.code == 200){
                  sessionStorage.removeItem("setpForm")
                  this.$message.success("保存成功");
                  this.$router.go(-1);
                }     
              });
            }else {
              sessionStorage.setpForm = JSON.stringify(param);
              this.$emit('next');
            }
            
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        })
      },
      addMainNum(){
        this.cForm1.subjectNum++
      },
      delMainNum(i){
        let mainArry = []
        for(let j=0; j<this.cForm1.subjectNum; j++ ){
          mainArry[j] = this.cForm1['subjectName'+(j+3)]
        }
        this.cForm1.subjectNum--
        mainArry.splice(i-1, 1)

        for(let m=0; m<this.cForm1.subjectNum; m++ ){
          this.cForm1['subjectName'+(m+3)] = mainArry[m]
        }
        this.cForm1['subjectName'+(this.cForm1.subjectNum+3)] = ""
      },
      changeNode(item){
        if(item.isRequire == '0'){
          this.$message.error("此项为必须项，不能删除！");
          this.cForm1.authorityNodeArr.push(item)
        }
      },
      seteNode(obj){
        this.clearData()
        obj.forEach((item, i) => {
          if(item.nodeName == this.cForm1.lawFirmName){
            this.$message.error("律所与权威节点不能选择相同机构！");
            this.cForm1.authorityNodeArr.splice(i, 1)
          }
        })
      },
      setLawFirm(obj){
        // 律所与权威节点不能相同
        let index = this.cForm1.authorityNodeArr.findIndex((item) => item.nodeName === obj.nodeName); 
        if(index >= 0){
          this.$message.error("律所与权威节点不能选择相同机构！");
          delete this.cForm1['lawFirmObj']
        }else {
          this.cForm1.lawFirmName = obj.nodeName
          this.cForm1.lawFirm = obj.nodeId
        }      
      },
      getLawFirm(){
        this.$api.api.getDicts("zqzl_save_type").then(response => {
            this.typeOptions = response.data;
        });
        this.$api.api.getDicts("payment_method").then(response => {
            this.repayOptions = response.data;
        });
        this.$api.api.nodeList({...this.queryParams,nodeType:'2'}).then(response => {
          if(response.code == 200){
            this.lawOptions = response.rows          
            if(this.cForm1.lawFirmName){
              this.$set(this.cForm1, 'lawFirmObj', {
                nodeName: this.cForm1.lawFirmName,
                nodeId: this.cForm1.lawFirm
              })
            }

          }else {
            this.$message.error(response.msg);
          }      
        });
      },
      uniqueFun(arr,type){
        const res = new Map();
        return arr.filter((a)=>!res.has(a[type])&& res.set(a[type],1));
      },
      getNodeList(){
        this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
          if(response.code == 200){
            this.nodeOptions = response.rows
            this.nodeTotal = response.total
            let authorityArr = []    
            this.nodeOptions.forEach(item => {
              if(item.isRequire == '0'){
                authorityArr.push({
                  id: item.id,
                  nodeName: item.nodeName
                })
              }
            })  
            if(this.cForm1.authorityNode){            
              let nodeArr = JSON.parse(this.cForm1.authorityNode)
              nodeArr.forEach(item =>{
                if(this.nodeOptions.findIndex((v) => {return v.id == item.id;}) >= 0){
                  authorityArr.push({
                    id: item.id,
                    nodeName: item.name
                  })
                }             
              })
            }    
            this.$set(this.cForm1, 'authorityNodeArr', this.uniqueFun(authorityArr, 'id')) 
          }else {
            this.$message.error(response.msg);
          }      
        });
      },
    }
	}
</script>